import React from 'react';
import { useLocation } from 'react-router-dom';

import AcceptTransferModal from './components/AcceptTransferModal';
import DeclineTransferModal from './components/DeclineTransferModal';

function TransferBookingModals() {
  const location = useLocation();
  const pathname = location.pathname;
  const showAccept = pathname.endsWith('/accept');
  const showDecline = pathname.endsWith('/decline');

  return (
    <>
      {showAccept && <AcceptTransferModal />}
      {showDecline && <DeclineTransferModal />}
    </>
  );
}

export default TransferBookingModals;
